// 수면음원 특화 유틸리티 함수

// 공통 함수들 import
export * from './musicCommon.js';

// 수면음원 카테고리별 테두리 색상 (수면음원 특화)
export const CATEGORY_BORDER_COLORS = {
  17: "border-info", // Jazz
  18: "border-success", // Nature
  19: "border-warning", // ASMR
  20: "border-danger", // Classic
  21: "border-primary", // White Noise
};

// 수면음원 카테고리 테두리 색상 함수 (수면음원 특화)
export function getCategoryBorderColor(categoryId) {
  return CATEGORY_BORDER_COLORS[categoryId] || "border-secondary";
} 